import { HOME_PORTALS, HOME_TOOLS, HOME_DESTINATIONS } from './homeDestinations';

export const HOME_TOPICS = [
  {id:'design',label:'Design',portal:'developments'}, {id:'quality',label:'Quality control',portal:'qc'},
  {id:'orders',label:'Orders',portal:'orders'}, {id:'logistics',label:'Logistics',portal:'orders'},
  {id:'sales',label:'Sales',portal:'sales'}, {id:'catalog',label:'Catalog',portal:'catalog'},
];
const ids = defs => defs.map(d => d.id);
const list = (value, allowed, fallback) => Array.isArray(value)
  ? [...new Set(value.filter(v => typeof v === 'string' && allowed.includes(v)))] : [...fallback];
const ordered = (value, allowed) => [...list(value,allowed,[]), ...allowed.filter(id => !Array.isArray(value) || !value.includes(id))];
export const isObject = v => !!v && typeof v === 'object' && !Array.isArray(v);
export function normalizeHomePreferences(raw) {
  const v = isObject(raw) ? raw : {};
  const fixedTools = ids(HOME_TOOLS);
  const shortcutCards = list(v.shortcutCards,ids(HOME_DESTINATIONS).filter(id => !fixedTools.includes(id)),[]);
  return {
    version:1,
    portalOrder:ordered(v.portalOrder,ids(HOME_PORTALS)),
    toolOrder:ordered(v.toolOrder,[...fixedTools,...shortcutCards]),
    shortcutCards,
    pins:list(v.pins,ids(HOME_DESTINATIONS),['order-desk','development-board','qc-reports']),
    toolsSide:v.toolsSide === 'left' ? 'left' : 'right',
    workFocus:list(v.workFocus,ids(HOME_TOPICS),[]),
    density:v.density === 'compact' ? 'compact' : 'comfortable',
    updates:typeof v.updates === 'boolean' ? v.updates : true,
  };
}
export const designerIdentity = profile => typeof profile?.my_designer_name === 'string'
  ? profile.my_designer_name.trim() || null : null;

// Move only visible slots; permission-hidden IDs keep their saved positions.
export function reorderVisible(savedOrder, visibleOrder) {
  const selected = new Set(visibleOrder);
  let i = 0;
  return savedOrder.map(id => selected.has(id) ? visibleOrder[i++] : id);
}
export function mergeHomePreferences(preferences, patch) {
  const prefs = isObject(preferences) ? preferences : {};
  const home = isObject(prefs.home) ? prefs.home : {};
  return {...prefs,home:{...home,...normalizeHomePreferences({...home,...patch})}};
}
